<template>
  <div>
    <v-chart :options="option" v-if="isShow" ref="chart"></v-chart>
  </div>
</template>

<script>
import "echarts/lib/chart/line";
import "echarts/lib/component/legend";
import "echarts/lib/chart/bar";
import util from "@/util/util.js";
export default {
  props: {
    list: {
      default: () => [],
    },
    list2: {
      default: () => [],
    },
  },
  watch: {
    list2(nv) {
      this.option.series[0].data = this.list;
      this.option.series[1].data = nv;
      this.option.xAxis.data = util.getPastSevenDate();
      this.isShow = true;
    },
  },
  data() {
    let that = this;
    return {
      isShow: false,
      option: {
        color: ["#00B8FF", "#FC7204"],
        grid: {
          height: "85%",
          width: "85%",
          x: "center",
          y: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "horizontal",
          x: "center", //可设定图例在左、右、居中
          y: "top", //可设定图例在上、下、居中
          padding: [0, 50, 0, 0],
          textStyle: {
            color: "#8a8888",
          },
          data: [
            that.$t("charts.holderAccounts"),
            that.$t("charts.unHolderAccounts"),
          ],
        },
        xAxis: {
          type: "category",
          data: [],
          axisLabel: {
            margin: 10,
            color: "#FFFFFF",
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              color: "none",
            },
          },
          splitLine: {
            lineStyle: {
              color: "#333",
            },
          },
          axisLabel: {
            textStyle: {
              color: "#CCC",
            },
          },
        },
        series: [
          {
            name: that.$t("charts.holderAccounts"),
            data: [],
            type: "bar",
            barWidth: 40,
            symbol: "none",
            itemStyle: {
              normal: {
                lineStyle: {
                  color: "#00B8FF",
                },
              },
            },
          },
          {
            name: that.$t("charts.unHolderAccounts"),
            data: [],
            type: "bar",
            barWidth: 40,
            symbol: "none",
            itemStyle: {
              normal: {
                lineStyle: {
                  color: "#00B8FF",
                },
              },
            },
          },
        ],
      },
    };
  },
  mounted() {
    let that = this;
    window.addEventListener("resize", () => {
      try {
        that.$refs.chart.resize();
      } catch (e) {}
    });
  },
};
</script>